







import { isDevelopment } from "@/api/utils";
// Libraries
import { Component, Vue } from "vue-property-decorator";
// Components
import QuotesWrapper from "@/components/QuotesWrapper.vue";
import CreateQuote from "@/components/CreateQuote.vue";

@Component({
  components: {
    QuotesWrapper,
    CreateQuote,
  },
})
export default class App extends Vue {
  created(): void {
    if (!isDevelopment) {
      window.onstorage = () => {
        const quotes = this.$store.state.quotes || [];
        localStorage.setItem("quotes", JSON.stringify(quotes));
      };
    }
  }
}
